/**
 * Detects presence of given selectors on the
 * page. If one is found, saves it and flags
 * as present. Only one selector needs be
 * found before it short-circuits out.
 */
export class SelectorDetector {
  readonly present: boolean = false
  readonly selector: string | undefined

  constructor(
    readonly selectors: Array<string>,
    readonly _document: Document = document
  ) {
    for (const selector of selectors) {
      const result = _document.querySelector(selector)
      if (result) {
        this.present = true
        this.selector = selector
        break
      }
    }
  }
}
